/**
 * API service for signup functionality
 */

// const API_BASE_URL = 'https://osiad3ts00.execute-api.ap-south-1.amazonaws.com/dev';
const POWER_AUTOMATE_URL =
    'https://a4fce81eef4be4889ed4066d1378ef.d4.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/516f8b8428c3443baeb96d7f413c4a51/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=NOJjui7Dybg7gTBr-qwmAqc5w42ktO5o3sorZmgUTjs';

/**
 * Submit signup form data to the backend
 * @param {Object} formData - Form data object
 * @param {string} formData.fullName - Full name (required)
 * @param {string} formData.email - Email address (required)
 * @param {string} formData.city - City (required)
 * @param {string} formData.organizationType - Organization type (required)
 * @param {string} formData.organizationName - Organization name (optional)
 * @param {string} formData.role - Role/Position (optional)
 * @param {string} formData.message - Message (optional)
 * @returns {Promise<Object>} Response object with status and data
 */
export const submitSignup = async (formData) => {
    try {
        // Prepare API payload
        const payload = {
            fullName: formData.fullName.trim(),
            email: formData.email.trim(),
            city: formData.city.trim(),
            organizationType: formData.organizationType,
            organizationName: formData.organizationName.trim() || '',
            role: formData.role.trim() || '',
            message: formData.message.trim() || ''
        };

        console.log('API Request (Power Automate only):', payload);

        // Directly call Power Automate HTTP trigger
        const response = await fetch(POWER_AUTOMATE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        let responseData = null;
        try {
            responseData = await response.json();
        } catch (e) {
            // If the flow returns no JSON body, ignore parsing error
            responseData = null;
        }

        console.log('Power Automate Response:', responseData);

        return {
            ok: response.ok,
            status: response.status,
            data: responseData,
        };
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

